var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.betukod)?_c('span',{staticClass:"forgalmi-prefix"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.betukod)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }